module.exports = __webpack_public_path__ + "img/logo-W3P-tmp.2cd7e177.svg";